import { BillingRecurringTypes } from "app/models/ss-api/price.billing.cycle";

export interface IUpdateCartRequest {

    ProductID: Number;
    CartID: string;
    RedirectID: Number;
    DateTimeRedirectClicked: Date
    FirstName: string;
    LastName: string;
    Email1: string;
    Email2: string;
    Company: string;
    Phone: string;
    CCName: string;
    CCNumber: string;
    CCLastFour: string;
    CCExpMonth: number;
    CCExpYear: number;
    Address: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;
    Initials: string;
    BillingCycle: BillingRecurringTypes;
    SubTotal: number;
    TaxChecksum: string;
}

export class UpdateCartRequest implements IUpdateCartRequest {

    public Company: string;
    public ProductID: Number;
    public RedirectID: Number;
    public DateTimeRedirectClicked: Date;
    public FirstName: string;
    public LastName: string;
    public Email1: string;
    public Email2: string;
    public CartID: string;
    public Phone: string;
    public CCName: string;
    CCNumber: string;
    CCLastFour: string;
    CCExpMonth: number;
    CCExpYear: number;
    public Address: string;
    public City: string;
    public State: string;
    public ZipCode: string;
    public Country: string;
    public Initials: string;
    BillingCycle: BillingRecurringTypes;
    SubTotal: number;
    TaxChecksum: string;
}